/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_NowInputs */

const vi_station_work_now = /** @type {(inputs: Station_Work_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bây giờ`)
};

/**

* @param {Station_Work_NowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_now = /** @type {((inputs?: Station_Work_NowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_NowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_now(inputs)
});